import { PostgresIconUrl } from "@p0security/integrations-postgres-shared/registry";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { PostgresLegacyAccesses } from "./accesses.ts";
import { PostgresLegacyComponents } from "./components.ts";

const PostgresLegacyFilters = {
  instance: { keys: ["name"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;

export type PostgresLegacyFilters = typeof PostgresLegacyFilters;

export const PostgresLegacyRegistration = Registration({
  accesses: PostgresLegacyAccesses,
  category: "resource",
  components: PostgresLegacyComponents,
  docs: { install: "postgresql" },
  filters: PostgresLegacyFilters,
  // Hidden unless a tenant still on the legacy integration has this flag on
  flag: "postgres-legacy-integration",
  itemKind: "database",
  label: "PostgreSQL (Legacy)",
  logoUrl: PostgresIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "access-management" }],
});

registerIntegration("pg", PostgresLegacyRegistration);
